var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player-wrapper",on:{"mouseover":_vm.handleMouseover,"mouseout":_vm.handleMouseout}},[_c('video',{ref:"videoPlayer",attrs:{"id":"video","src":_vm.url,"preload":_vm.preload},domProps:{"muted":_vm.muted}})])}
var staticRenderFns = []

export { render, staticRenderFns }